import apiClient from './apiClient'

/**
 * Fund API Service
 */

const fundService = {

    // MARK: FETCH FUNDS SUMMARY

    /**
     * Fetch fund summary
     * GET /campaigns/funds/summary
     * 
     * @param {object} options - Optional { showSnackbar, showSuccessSnackbar, successMessage, errorMessage }
     * @returns {Promise} Fund summary
     */
    fetchFundsSummary: async (options = {}) => {
        const response = await apiClient.get(
            '/campaigns/funds/summary',
            {
                ...options,
            }
        )
        return response.data
    },

    // MARK: GET INVOICES

    /**
     * Get invoices
     * GET /campaigns/funds/invoices
     * 
     * @param {number} pageNumber - Page number
     * @param {number} pageSize - Page size
     * @param {object} options - Optional { showSnackbar, showSuccessSnackbar, successMessage, errorMessage }
     * @returns {Promise} Invoices
     */
    getInvoices: async (pageNumber = 1, pageSize = 10, options = {}) => {
        const response = await apiClient.get('/campaigns/funds/invoices', {
            ...options,
            params: {
                pagenumber: pageNumber,
                pagesize: pageSize,
            }
        })
        return response.data
    },

    // MARK: PURCHASE FUNDS

    /**
     * Purchase funds
     * POST /campaigns/funds/request
     * 
     * @param {object} payload - The payload object { currencyamount }
     * @param {object} options - Optional { showSnackbar, showSuccessSnackbar, successMessage, errorMessage }
     * @returns {Promise} Purchase result
     */
    purchaseFunds: async (payload, options = {}) => {
        const response = await apiClient.post(
            '/campaigns/funds/request',
            payload,
            options
        )
        return response.data
    },

    // MARK: FETCH FUNDS TEMPLATE

    /**
     * Fetch funds upload template
     * GET /upload/funds/template
     * 
     * @param {object} options - Optional { showSnackbar, showSuccessSnackbar, successMessage, errorMessage }
     * @returns {Promise} Template URL { url: string }
     */
    fetchFundsTemplate: async (options = {}) => {
        const response = await apiClient.get(
            '/upload/funds/template',
            options
        )
        return response.data
    }

}

export default fundService
